const url = (url: string, absolute?: boolean) => {
    if (absolute) return process.env.REACT_APP_APP_URL + url;

    return url;
}
export const profileLink = (slug: string, absolute?: boolean): string => url("/" + slug + "/", absolute);
export const profileActivityLink = (slug: string, uuid: string, absolute?: boolean): string => url("/" + slug + "/activities/" + uuid + "/", absolute);